module.exports = __webpack_public_path__ + "static/media/img22.d8aa9e4a.jpg";